export default "__VITE_ASSET__1a08735f__"